import { MOBILE_BREAKPOINT, ROUTE_MAP } from '../constants/mainLayout';
import { HiOutlineSquares2X2 as DashboardIcon } from 'react-icons/hi2';

/**
 * Check if device is mobile
 * @returns {boolean} True if mobile device
 */
export const isMobile = () => window.innerWidth <= MOBILE_BREAKPOINT;

/**
 * Get page title from route
 * @param {Object} location - React Router location object
 * @param {Object} routeMap - Route mapping object
 * @returns {string} Page title
 */
export const getPageTitle = (location, routeMap = ROUTE_MAP) => {
  // Exact match first
  if (routeMap[location.pathname]) {
    return routeMap[location.pathname].title;
  }
  
  // Check for partial matches (for nested routes)
  const matchedRoute = Object.keys(routeMap).find((path) => 
    location.pathname.startsWith(path)
  );
  
  return matchedRoute ? routeMap[matchedRoute].title : 'Dashboard';
};

/**
 * Get page icon component from route
 * @param {Object} location - React Router location object
 * @param {Object} routeMap - Route mapping object
 * @returns {JSX.Element} Icon component
 */
export const getPageIcon = (location, routeMap = ROUTE_MAP) => {
  // Exact match first
  let IconComponent = DashboardIcon;
  
  if (routeMap[location.pathname]) {
    IconComponent = routeMap[location.pathname].icon;
  } else {
    // Check for partial matches (for nested routes)
    const matchedRoute = Object.keys(routeMap).find((path) => 
      location.pathname.startsWith(path)
    );
    
    if (matchedRoute) {
      IconComponent = routeMap[matchedRoute].icon;
    }
  }
  
  return <IconComponent style={{ fontSize: '20px', width: '20px', height: '20px' }} />;
};

/**
 * Get user initials from user object
 * @param {Object} user - User object
 * @returns {string} User initials (uppercase, max 2 characters)
 */
export const getUserInitials = (user) => {
  const displayName = user?.full_name || user?.name;
  if (!displayName) return 'U';
  return displayName
    .split(' ')
    .map(n => n.charAt(0))
    .join('')
    .substring(0, 2)
    .toUpperCase();
};

/**
 * Check if current page is Power BI Dashboard
 * @param {Object} location - React Router location object
 * @returns {boolean} True if Power BI page
 */
export const isPowerBIPage = (location) => {
  return location.pathname === '/dashboard/analytics/powerbi';
};
